import {InitData, Utils} from "@tma.js/sdk-react";
import {webappAddress} from "../../communication/communication";

function shareRefLink(initData : InitData, utils : Utils) {
    if (initData === undefined) return;

    if (initData?.user === undefined) return;
    const id = initData.user.id
    const encoded = id.toString(36);
    const url = `${webappAddress}?startapp=${encoded}`
    const data = `https://t.me/share/url?url=${url}`
    utils!.openTelegramLink(data)
}
export function getBehaviour(initData : InitData, utils : Utils, code : string) {
    switch (code) {
        case "Friend":
        case "Friend3":
            return () => handleFriendsClick(initData, utils)
    }

    return logError
}

function handleFriendsClick(initData : InitData, utils : Utils){
    shareRefLink(initData, utils)
}

function logError(){
    console.error("Error, unknown task type!")
}